module.exports = __webpack_public_path__ + "static/media/Style16.7784b3b1.PNG";